<template>
  <SingleSelect
    v-model="scheduledItems"
    :searchable="false"
    :items="selectItems"
    :label="label"
    :placeholder="placeholder"
    :clearable="clearable"
    :disabled="disabled"
    @clearClick="$emit('clearInfo', label)"
  >
    <template v-slot:selection="{item}">
      <span
        class="grey--text caption"
      >
        {{ item.text }}
      </span>
    </template>
  </SingleSelect>
</template>

<script>
import SingleSelect from '@/components/filter/models/SingleSelect';

export default {
  name: 'ScheduledFilter',
  components: {
    SingleSelect,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    filter: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default() {
        return this.$t('components.filters.ScheduledFilter.placeholder');
      },
    },
  },
  data() {
    return {};
  },
  computed: {
    label() {
      return this.$t('components.filters.ScheduledFilter.label');
    },
    selectItems() {
      return [
        {
          text: this.$t('components.filters.ScheduledFilter.items.all'),
          value: false,
        },
        {
          text: this.$t('components.filters.ScheduledFilter.items.onlyScheduled'),
          value: true,
        },
      ];
    },
    scheduledItems: {
      get() {
        return this.value?.value;
      },
      set(newValue) {
        let value;

        if (newValue !== null && newValue !== undefined) {
          value = {
            value: newValue,
          };
        }
        if (newValue === undefined) {
          value = {
            value: false,
          };
        }

        this.$emit('input', value);
      },
    },
  },
};

</script>

  <style scoped lang="scss">
    .v-select__selection.v-select__selection--comma {
      line-height: 120%;
    }
  </style>
